import type { VulnerabilityOrRemediationType } from '../VulnerabilityManagement.types';

const EMPTY_VULNERABILITY_PAGE: VulnerabilityOrRemediationType = {
  id: 0,
  name: '',
  shield_exposure_index: 0,
  severity: 'Low',
  description: '',
  solution: '',
  category: '',
  port_number: 0,
  cve: '',
  cvss: 0,
  epss: 0,
  epss_percentile: 0,
  exploited: false,
  known_ransomware_campaign_use: false,
  synopsis: '',
  scanner_name: '',
  scanner_type: 'Attack Surface',
  created_at: '',
  updated_at: '',
  pondurance_score: '',
  assets: [],
  remediated_assets: [],
  date_identified: '',
  organization_id: 0,
  shield_type: '',
  references: ''
};

export const VULNERABILITIES_GROUP_BY_FIELDS: string[] = [
  'scanner_type',
  'cvss_level',
  'pondurance_score',
  'date_remediated__isnull',
  'severity',
  'vmp_severity'
];

export default EMPTY_VULNERABILITY_PAGE;
